(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("6bCCL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4811bb1c9b570b64$export$6503ec6e8aabbaf; }, function (v) { return $4811bb1c9b570b64$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4811bb1c9b570b64$export$f7ad0328861e2f03; }, function (v) { return $4811bb1c9b570b64$export$f7ad0328861e2f03 = v; });
var $4811bb1c9b570b64$export$6503ec6e8aabbaf;
var $4811bb1c9b570b64$export$f7ad0328861e2f03;
"use strict";
var $4811bb1c9b570b64$var$mapping = {};
function $4811bb1c9b570b64$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$4811bb1c9b570b64$var$mapping[keys[i]] = pairs[keys[i]];
}
function $4811bb1c9b570b64$var$resolve(id) {
    var resolved = $4811bb1c9b570b64$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$4811bb1c9b570b64$export$6503ec6e8aabbaf = $4811bb1c9b570b64$var$register;
$4811bb1c9b570b64$export$f7ad0328861e2f03 = $4811bb1c9b570b64$var$resolve;

});

parcelRequire.register("htNVm", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("LGZSr")).then(()=>parcelRequire("1hdTd"));

});
parcelRequire.register("d7xei", function(module, exports) {
"use strict";

var $fySXl = parcelRequire("fySXl");
module.exports = $fySXl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("fySXl", function(module, exports) {
"use strict";
var $b544a9276db09370$var$cachedBundles = {};
var $b544a9276db09370$var$cachedPreloads = {};
var $b544a9276db09370$var$cachedPrefetches = {};
function $b544a9276db09370$var$getCache(type) {
    switch(type){
        case "preload":
            return $b544a9276db09370$var$cachedPreloads;
        case "prefetch":
            return $b544a9276db09370$var$cachedPrefetches;
        default:
            return $b544a9276db09370$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $b544a9276db09370$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("fCnh5", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $b5ec75749f6d674c$export$bdfd709ae4826697; }, function (v) { return $b5ec75749f6d674c$export$bdfd709ae4826697 = v; });
var $b5ec75749f6d674c$export$bdfd709ae4826697;
var $b5ec75749f6d674c$export$c9e73fbda7da57b6;
var $b5ec75749f6d674c$export$5a759dc7a1cfb72a;
"use strict";
var $b5ec75749f6d674c$var$bundleURL = {};
function $b5ec75749f6d674c$var$getBundleURLCached(id) {
    var value = $b5ec75749f6d674c$var$bundleURL[id];
    if (!value) {
        value = $b5ec75749f6d674c$var$getBundleURL();
        $b5ec75749f6d674c$var$bundleURL[id] = value;
    }
    return value;
}
function $b5ec75749f6d674c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $b5ec75749f6d674c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $b5ec75749f6d674c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $b5ec75749f6d674c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$b5ec75749f6d674c$export$bdfd709ae4826697 = $b5ec75749f6d674c$var$getBundleURLCached;
$b5ec75749f6d674c$export$c9e73fbda7da57b6 = $b5ec75749f6d674c$var$getBaseURL;
$b5ec75749f6d674c$export$5a759dc7a1cfb72a = $b5ec75749f6d674c$var$getOrigin;

});


parcelRequire.register("h3uRS", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("e3lPu")).then(()=>parcelRequire("auC0w"));

});

parcelRequire.register("1o9BO", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("MujTN")).then(()=>parcelRequire("9OVZq"));

});

parcelRequire.register("2mHKo", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("lpyve")).then(()=>parcelRequire("14fJ4"));

});

parcelRequire.register("8aTBG", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("aXktb")).then(()=>parcelRequire("bj9Kj"));

});

parcelRequire.register("5HNut", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("fGUW4")).then(()=>parcelRequire("6FjDL"));

});

parcelRequire.register("9h4ej", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("euwNc")).then(()=>parcelRequire("fsH90"));

});

parcelRequire.register("jOVMu", function(module, exports) {



module.exports = (parcelRequire("d7xei"))((parcelRequire("fCnh5")).getBundleURL("bEOY1") + (parcelRequire("6bCCL")).resolve("bIGPh")).then(()=>parcelRequire("90JZI"));

});

var $cbebde59f51daeab$exports = {};

(parcelRequire("6bCCL")).register(JSON.parse('{"bEOY1":"main.js","LGZSr":"nav.cbd13082.js","e3lPu":"user-menu.68af4b23.js","MujTN":"image-loader.1da832c1.js","lpyve":"bulk-image-loader.781b8d2a.js","aXktb":"accordion.91679355.js","fGUW4":"new_order.5b879800.js","euwNc":"search-bars.92938ee4.js","bIGPh":"password.69e7faca.js","bfEf7":"main.css"}'));

function $89861ddc8389d587$export$ae2db8e4e94b058() {
    const wasShown = localStorage.getItem("tutorial-was-shown") === "true";
    const nav = document.querySelector("#main-nav");
    if (!wasShown) {
        const tutorial = document.createElement("div");
        tutorial.innerHTML = `\
    <div id="tutorial-container" class="absolute left-[5rem] top-[5rem] bg-white max-w-[267px] z-50 drop-shadow-md rounded-lg flex flex-col gap-3">\
      <div class="px-5 pt-5 flex justify-between">\
        <h2 class="text-lg text-light-blue">Tutorial</h2>\
        <button id="tutorial-close-button">\
          <img src="../static/img/x.svg" class="stroke-dark-blue" />\
        </button>\
      </div>\
      <p id="tutorial-text" class="px-5 text-light-blue text-opacity-50 font-normal">\
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi quis elit non velit fringilla \
      </p>\
      <div class="flex justify-center gap-2 py-2">\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green w-5 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
      
      </div>\
      <div class="flex">\
        <button id="tutorial-last-button" class="p-4 flex-1 bg-dark-blue text-white rounded-bl-lg">Anterior</button>\
        <button id="tutorial-next-button" class="p-4 flex-1 bg-ecofactory-green text-white rounded-br-lg">Siguiente</button>\
      </div>\
    </div>\
  `;
        nav.appendChild(tutorial);
        const tutorialClose = document.querySelector("#tutorial-close-button");
        const tutorialNext = document.querySelector("#tutorial-next-button");
        const tutorialLast = document.querySelector("#tutorial-last-button");
        const tutorialText = document.querySelector("#tutorial-text");
        const tutorialPageIndicator = document.querySelectorAll("#tutorial-page-indicator");
        const textPages = 3;
        let currentTextPage = 0;
        const textPagesParagraphs = {
            0: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi quis elit non velit fringilla",
            1: "Lorem ipsum dolor sit amet, consectetur adipisciit. Morbi quis elit non velit fringilla",
            2: "Lorem ipsum dolor sit amet, consectetur adipiscing el. Morbi quis elit non velit fringilla",
            3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit Morbi quis elit non velit fringilla"
        };
        tutorialClose.addEventListener("click", ()=>{
            tutorial.classList.add("hidden");
            localStorage.setItem("tutorial-was-shown", true);
        });
        tutorialNext.addEventListener("click", ()=>{
            if (currentTextPage == textPages) return;
            tutorialPageIndicator[currentTextPage].classList.add("bg-opacity-50");
            currentTextPage += 1;
            tutorialText.innerHTML = textPagesParagraphs[currentTextPage];
            tutorialPageIndicator[currentTextPage].classList.remove("bg-opacity-50");
        });
        tutorialLast.addEventListener("click", ()=>{
            if (currentTextPage == 0) return;
            tutorialPageIndicator[currentTextPage].classList.add("bg-opacity-50");
            currentTextPage -= 1;
            tutorialText.innerHTML = textPagesParagraphs[currentTextPage];
            tutorialPageIndicator[currentTextPage].classList.remove("bg-opacity-50");
        });
    }
}













document.addEventListener("DOMContentLoaded", ()=>{
    /**
   * Main nav
   */ const mainNav = document.querySelectorAll("#main-nav");
    if (mainNav.length > 0) (parcelRequire("htNVm")).then((module)=>{
        module.navHandler();
    });
    /**
   * User menu
   */ const userMenu = document.querySelectorAll("#user-menu");
    if (userMenu.length > 0) (parcelRequire("h3uRS")).then((module)=>{
        module.userMenuHandler();
    });
    /**
   * Image loader
   */ const imageLoader = document.querySelectorAll("#image-loader");
    if (imageLoader.length > 0) (parcelRequire("1o9BO")).then((module)=>{
        module.imageLoaderHandler();
    });
    /**
   * Image loader
   */ const bulkImageLoader = document.querySelectorAll("#bulk-image-loader");
    if (bulkImageLoader.length > 0) (parcelRequire("2mHKo")).then((module)=>{
        module.imageLoaderHandler();
    });
    /**
   * Accordions
   */ const accordions = document.querySelectorAll(".accordion");
    if (accordions.length > 0) (parcelRequire("8aTBG")).then((module)=>{
        module.accordionHandler();
    });
    /**
   * New Order
   */ const new_order = document.querySelectorAll("#new_order");
    if (new_order.length > 0) (parcelRequire("5HNut")).then((module)=>{
        module.categoryHandler();
        module.orderParse();
    });
    /**
   * Users search box
   */ const usersSearchBox = document.querySelectorAll("#usersSearch");
    if (usersSearchBox.length > 0) (parcelRequire("9h4ej")).then((module)=>{
        module.usersSearchHandler();
    });
    /**
   * Products search box
   */ const productsSearchBox = document.querySelectorAll("#productSearch");
    if (productsSearchBox.length > 0) (parcelRequire("9h4ej")).then((module)=>{
        module.productsSearchHandler();
    });
    /**
   * Orders search box
   */ const ordersSearchBox = document.querySelectorAll("#ordersSearch");
    if (ordersSearchBox.length > 0) (parcelRequire("9h4ej")).then((module)=>{
        module.ordersSearchHandler();
    });
    /**
   * Login form password padding
   */ const formLogin = document.querySelector("#formLogin");
    if (formLogin !== null) (parcelRequire("jOVMu")).then((module)=>{
        module.passwordHandler(formLogin);
    });
    (0, $89861ddc8389d587$export$ae2db8e4e94b058)();
});

})();
//# sourceMappingURL=main.js.map
